import type { SVGProps } from 'react';

export function DeviceTrezorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18 16.75V10h2v6.75A6.25 6.25 0 0 1 13.75 23H11.5a4 4 0 0 1-4-4h2a2 2 0 0 0 2 2h2.25A4.25 4.25 0 0 0 18 16.75M9.493 9.031a.5.5 0 0 1 .5.5v1.421a.5.5 0 0 1-.296.456l-.993.446a.5.5 0 0 1-.41 0l-.992-.446a.5.5 0 0 1-.295-.456v-1.42a.5.5 0 0 1 .5-.5zM8.5 6.871c.486 0 .868.335.868.754v.019a.5.5 0 0 1-.5.5h-.736a.5.5 0 0 1-.5-.5v-.019c0-.419.382-.754.868-.754" />
      <path d="M12.053 3a2 2 0 0 1 2 2v7.002a2 2 0 0 1-.211.893l-2 4A2 2 0 0 1 10.054 18H6.999a2 2 0 0 1-1.789-1.105l-2-4a2 2 0 0 1-.21-.893V5a2 2 0 0 1 2-2zM8.5 6c-.972 0-1.771.737-1.771 1.625v.154a.364.364 0 0 1-.365.365.365.365 0 0 0-.364.364v3.047a.5.5 0 0 0 .295.456l2 .897a.5.5 0 0 0 .41 0l2-.897a.5.5 0 0 0 .295-.456v-3.03a.364.364 0 0 0-.364-.365.366.366 0 0 1-.365-.364v-.171C10.27 6.737 9.472 6 8.5 6M17 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V7a2 2 0 1 1-4 0z" />
    </svg>
  );
}
